import { HttpInterceptorFn } from "@angular/common/http";
import { CompanyService } from "~/core/services/company.service";

export const versionInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== "PUT") {
    return next(req);
  }

  const backofficeVersion = CompanyService.currentSysConfig.platform_versions?.backoffice;

  // Se não existir, segue a request original
  if (!backofficeVersion) {
    return next(req);
  }

  const modifiedReq = req.clone({
    setHeaders: {
      "x-system-version": backofficeVersion,
    },
  });
  return next(modifiedReq);
};
